import { ExtraCost } from "./extraCostParametersValues.model";
import { BonusScheme, MarketFamily, OfferScheme, OfferValidity } from "./headerParametersValues.model";
import { Mill, Sql, SurfaceTypes, TubeExecution } from "./itemParametersValues.model";
import { ItemLimitation } from "./itemToUpdate.model";
import { Material } from "./materials.model";

export class EnquiryAttachment {
    enquiryAttachmentId?: number;
    fileDate?: number;
    fileName?: string;
    presignedUrl?: string;
}

export class EnquiryAttachmentToDelete {
    enquiryNo?: string;
    fileId?: number;
}

export class CreateCustomerCountry {
    countryCode?: string;
    countryId?: number;
    countryName?: string;
    culture?: string;
}

export class EnquiryCustomer {
    customerId?: number;
    customerName?: string;
    customerCode?: string;
    isDummy?: boolean;
    customerCountry?: CreateCustomerCountry;
}

export class EnquiyNormGrade {
    normGradeId?: number;
    normGradeCode?: string;
}

export class EnquiryRawMaterialGrade {
    rawMaterialGradeId?: number;
    rawMaterialGradeCode?: string;
    isDefault?: boolean;
    isDummy?: boolean;
}

export class EnquiryNpsSchedule {
    npsScheduleId?: number;
    npsDescription?: string;
    nps?: string;
    schedule?: string;
    odMetric?: number;
    wtMetric?: number;
    odImperial?: number;
    wtImperial?: number;
}

export class EnquirySms {
    smsId?: number;
    name?: string;
    description?: string;
    marketingRoute?: string;
}

export class EnquiryHeader {
    enquiryNo?: string;
    salesPerson?: string;
    salesOffice?: string;
    customer?: EnquiryCustomer;
    unitSystem?: string;
    currency?: string;
    dueDate?: number;
    optionDate?: number;
    creationDate?: number;
    lastRevisionDate?: number;
    projectName?: string;
    alloySurcharge?: boolean;
    orderReason?: string;
    applicableNorms?: string;
    normGrades?: EnquiyNormGrade[];
    marketingGrade?: string;
    rawMaterialGrade?: EnquiryRawMaterialGrade;
    testCategory?: string;
    od?: number;
    odUom?: string;
    wt?: number;
    wtUom?: string;
    id?: number;
    idUom?: string;
    npsSchedule?: EnquiryNpsSchedule;
    sms?: EnquirySms;
    totalWeight?: number | null;
    totalWeightUom?: string;
    remark?: string;
    offerStatus?: string;
    feasibilityStatus?: string;
    costsStatus?: string;
    deliveryStatus?: string;
    marketFamily?: MarketFamily;
    customerEnquiryNo?: string;
    mstOfferStatus?: string;
    length?: number;
    lengthUom?: string;
    isTotalWeightEditable?: boolean;
    quotationExists?: boolean;
    isQuotationFinal?: boolean;
    enquiryAttachments?: EnquiryAttachment[];
    offerValidity?: OfferValidity;
    offerValidityDate?: number | null;
    orderExtraCost?: OrderExtraCost;
    quotationEnquiryNo?: string | null;
    customerSpecialRequirements?: CustomerSpecialRequirement[];
    customerRequestDate?: number | null;
    offerScheme?: OfferScheme;
    bonusScheme?: BonusScheme;
}

export class ItemAttachment implements Attachment {
    attachmentsId?: number | null;
    fileDate?: number;
    fileName?: string;
    presignedUrl?: string;
}

export class AttachmentToUpdate implements Attachment {
    fileContent?: string;
    fileName?: string;
    fileCreationDate?: number;
    attachmentsId?: number | null;
}

export class EnquiryHeaderItem {
    [key: string]: number | string | boolean | undefined | null | any;
    alloySurcharge?: boolean;
    energySurcharge?: boolean;
    itemNo?: string | null;
    customerItemNo?: string;
    applicableNorms?: string;
    normGrades?: EnquiyNormGrade[];
    gradeCustomerAnalysisLimitation?: ItemLimitation;
    gradeCustomerOtherLimitation?: ItemLimitation;
    rawMaterialGrade?: EnquiryRawMaterialGrade | null;
    testCondition?: string;
    quantity?: number | null;
    quantityUom?: string | null;
    od?: number;
    odUom?: string;
    odTolerancePlus?: number | null;
    odToleranceMinus?: number | null;
    odToleranceUom?: string;
    wt?: number;
    wtUom?: string;
    id?: number;
    idUom?: string;
    idTolerancePlus?: number | null;
    idToleranceMinus?: number | null;
    idToleranceUom?: string;
    npsSchedule?: EnquiryNpsSchedule | null;
    typeOfTolerance?: string | null;
    isActualCmManuallyChanged?: boolean;
    isFinalPriceManuallyChanged?: boolean;
    lengthType?: string;
    lengthMin?: number | null;
    lengthMax?: number | null;
    lengthUom?: string;
    multipleLength?: boolean;
    lengthNominal?: number | null;
    marketingRoute?: string;
    sms?: EnquirySms | null;
    ut?: boolean | null;
    hydroTest?: boolean | null;
    endsCondition?: string;
    ht?: boolean | null;
    htAdditional?: boolean | null;
    inspectionType3Dot2?: boolean | null;
    multipleCutting?: boolean | null;
    surfaceType?: SurfaceTypes | null;
    mill?: Mill | null;
    totalWeight?: number;
    totalWeightUom?: string;
    optionDate?: number | null;
    uBent?: boolean;
    itrIssued?: boolean;
    icrIssued?: boolean;
    idrIssued?: boolean;
    unitSystem?: string;
    currency?: string;
    marketFamily?: MarketFamily;
    customerDeliveryDate?: number | null;
    attachments?: Attachment[];
    dueDate?: number;
    tubeExecution?: TubeExecution | null;
    wtTolerancePlus?: number | null;
    wtToleranceMinus?: number | null;
    wtToleranceUom?: string;
    remark?: string | null;
    fullCost?: number;
    recommendedPrice?: number;
    minimumPrice?: number;
    finalPrice?: number;
    finalPricePerLength?: number;
    minimumFm?: number;
    recommendedFm?: number;
    actualFm?: number;
    actualFmAmountPerWeight?: number;
    extraCosts?: number | null;
    extraCostsCollection?: ExtraCost[];
    sourceItemNo?: string | null;
    deliveryDate?: number;
    deliveryNotes?: string | null;
    deliverySource?: string;
    deliverySourceDescription?: string;
    deliveryDatesCollection?: DeliveryDate[];
    costsUom?: string;
    finalPricePerLengthUom?: string;
    finalPriceUom?: string;
    finalPricePerPiece?: number;
    finalPricePerPieceUom?: string;
    totalPriceUom?: string;
    agentFee?: number;
    customerBonus?: number;
    negotiationMargin?: number;
    weightPerLength?: number;
    remarks?: string | null;
    isImportedFromAI?: boolean;
    totalPrice?: number;
    cts?: boolean;
    dyePenetrant?: boolean;
    dyePenetrant100P?: boolean;
    penalty?: boolean;
    colorCoding?: boolean;
    specialOperations?: boolean;
    specialTests?: boolean;
    grindingHoning?: boolean;
    ec?: boolean;
    notStdPackaging?: boolean;
    material?: Material;
    costsStatus?: string;
    costsSourceCostingToolRecordId?: number | null;
    costsSourceCostingToolVersionId?: number | null;
    costsSourceCostingToolNearestRecordId?: number | null;
    extraLeadTime?: number;
    sql?: Sql;
    offerScheme?: OfferScheme;
    constructor() { }
}

export class Enquiry {
    enquiryNo?: string;
    header?: EnquiryHeader;
    items?: EnquiryHeaderItem[];
    hasPriceOrMarginChanges?: boolean;
}

export interface PriceOrMarginChangeValue {
    previousValue?: number | null;
    currentValue?: number | null;
}

export interface ItemWithPriceOrMarginChanges {
    itemNo?: string;
    fullCost?: PriceOrMarginChangeValue;
    customerBonus?: PriceOrMarginChangeValue;
    actualFm?: PriceOrMarginChangeValue;
    actualFmAmountPerWeight?: PriceOrMarginChangeValue;
    finalPrice?: PriceOrMarginChangeValue;
    alloySurchargeValue?: PriceOrMarginChangeValue;
}

export interface ItemsWithPriceOrMarginChangesResponse {
    items?: ItemWithPriceOrMarginChanges[];
}

export interface Attachment {
    fileDate?: number;
    presignedUrl?: string;
    fileContent?: string;
    fileName?: string;
    fileCreationDate?: number;
    attachmentsId?: number | null;
}

export class DeliveryDate {
    deliveryNumberOfWeeks?: number;
    deliveryNumberOfWeeksWithExtraLeadTime?: number;
    deliveryQuantity?: number;
    deliveryQuantityUom?: string;
    deliveryWeekOfYear?: string;
    deliveryWeekOfYearWithExtraLeadTime?: string;
}

export interface OrderExtraCost {
    amount?: number;
    uom?: string;
    items?: string[]
}

export class CustomerSpecialRequirement {
    rowNumber?: number;
    salesPersonComment?: string;
    millComment?: string;
    isCustomerRelevant: boolean = false;
    includeInQuotation?: boolean;
    itdcrMillId?: number;
}
